const TZ = 'Europe/Berlin';

const dtf = new Intl.DateTimeFormat('de-DE', { timeZone: TZ, dateStyle: 'medium', timeStyle: 'short' });
const df = new Intl.DateTimeFormat('de-DE', { timeZone: TZ, dateStyle: 'medium' });
const tf = new Intl.DateTimeFormat('de-DE', { timeZone: TZ, hour: '2-digit', minute: '2-digit' });

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '–';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '–' : dtf.format(d);
}
export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '–';
  const d = new Date(iso.length === 10 ? `${iso}T12:00:00Z` : iso);
  return Number.isNaN(d.getTime()) ? '–' : df.format(d);
}
export function formatTime(iso: string | null | undefined): string {
  if (!iso) return '–';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '–' : tf.format(d);
}

export function formatDuration(fromIso: string | null | undefined, toIso: string | null | undefined): string {
  if (!fromIso || !toIso) return '–';
  const ms = new Date(toIso).getTime() - new Date(fromIso).getTime();
  if (!Number.isFinite(ms) || ms < 0) return '–';
  const min = Math.round(ms / 60000);
  if (min < 1) return 'unter 1 Min.';
  if (min < 60) return `${min} Min.`;
  const h = Math.floor(min / 60);
  return `${h} Std. ${min % 60} Min.`;
}

export function relativeAge(iso: string | null | undefined, now = Date.now()): string {
  if (!iso) return '';
  const diff = Math.round((now - new Date(iso).getTime()) / 60000);
  if (!Number.isFinite(diff)) return '';
  if (diff < 1) return 'gerade eben';
  if (diff < 60) return `vor ${diff} Min.`;
  const h = Math.floor(diff / 60);
  if (h < 48) return `vor ${h} Std.`;
  return `vor ${Math.floor(h / 24)} Tagen`;
}

export function formatMinutes(min: number): string {
  if (min % 1440 === 0) return min === 1440 ? '24 Std.' : `${min / 1440} Tage`;
  if (min % 60 === 0) return min === 60 ? '60 Min. (stündlich)' : `${min / 60} Std.`;
  if (min > 60) return `${Math.floor(min / 60)} Std. ${min % 60} Min.`;
  return `${min} Min.`;
}

export function shortId(id: string): string {
  return id.slice(0, 8);
}
